module.exports = __webpack_public_path__ + "img/instagram-logo.4960d44d.svg";